import { TDeviceType } from '@cian/ui-kit';
import { LazyImage } from '../LazyImage';
import * as styles from './styles.css';
import { useState } from 'react';
import { clsx } from 'clsx';

interface IUtpItemProps {
  imageBg: string;
  imageFront: string;
  title: string;
  device: TDeviceType;
  frontMessage?: string;
  index: number;
}

export const UtpItem: React.FC<IUtpItemProps> = ({ imageBg, imageFront, device, title, frontMessage, index }) => {
  const [frontLoaded, setFrontLoaded] = useState(false);

  return (
    <div className={clsx(styles['utp-item'], styles[device])}>
      <div className={styles['utp-item-title']}>{title}</div>
      <div className={styles['images-wrapper']}>
        <LazyImage
          src={imageBg}
          alt={`bg-image ${index + 1}`}
          wrapperClassName={styles['image']}
          wrapperLoadingClassName={styles['disable-shadow']}
        />
        <LazyImage
          src={imageFront}
          alt={`front-image ${index + 1}`}
          wrapperClassName={styles['image-front']}
          wrapperLoadingClassName={styles['disable-shadow']}
          onLoad={() => setFrontLoaded(true)}
        />
        {frontMessage && frontLoaded && <div className={styles['front-message']}>{frontMessage}</div>}
      </div>
    </div>
  );
};
